import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import CustomerPerformanceActions from "../../../../reducers/modules/chart/customer-performance/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";
import i18n from "../../../../i18n";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "chart/customer-performance";

export default class CustomerPerformanceMiddleware {
  

  static setData(params) {
    return (dispatch) => {
      dispatch(CustomerPerformanceActions.process());
      CustomerPerformanceMiddleware.showData(dispatch, params);
    };
  }

  static setDataChart(params) {
    return (dispatch) => {
      dispatch(CustomerPerformanceActions.process());
      CustomerPerformanceMiddleware.showDataChart(dispatch, params);
    };
  }

  static setDataTable(params) {
    return (dispatch) => {
      dispatch(CustomerPerformanceActions.process());
      CustomerPerformanceMiddleware.showDataTable(dispatch, params);
    };
  }

  static setDataSales(params) {
    return (dispatch) => {
      dispatch(CustomerPerformanceActions.process());
      CustomerPerformanceMiddleware.showDataSales(dispatch, params);
    };
  }

  static setDataMonitor(params) {
    return (dispatch) => {
      dispatch(CustomerPerformanceActions.process());
      CustomerPerformanceMiddleware.showDataMonitor(dispatch, params);
    };
  }

  static reset() {
    return (dispatch) => {
      dispatch(CustomerPerformanceActions.reset());
    };
  }

  static resetList() {
    return (dispatch) => {
      dispatch(CustomerPerformanceActions.resetList());
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      CustomerPerformanceMiddleware.showHelper(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CustomerPerformanceMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-customer-chart",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(CustomerPerformanceActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        CustomerPerformanceMiddleware.alertHendler(dispatch, error);
      });
  }

  
  static showData(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CustomerPerformanceMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "chart/customer-performance",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
            dispatch(CustomerPerformanceActions.list(response.data.result)
            );
        }
      })
      .catch((error) => {
        CustomerPerformanceMiddleware.alertHendler(dispatch, error);
      });
  }

  static showDataChart(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CustomerPerformanceMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "chart/customer-performance-chart",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
            dispatch(CustomerPerformanceActions.listChart(response.data.result)
            );
        }
      })
      .catch((error) => {
        CustomerPerformanceMiddleware.alertHendler(dispatch, error);
      });
  }


  static showDataTable(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CustomerPerformanceMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "chart/sales-performance-table",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
            dispatch(CustomerPerformanceActions.listTable(response.data.result)
            );
        }
      })
      .catch((error) => {
        CustomerPerformanceMiddleware.alertHendler(dispatch, error);
      });
  }

    static showDataSales(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CustomerPerformanceMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "chart/customer-performance-sales",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
            dispatch(CustomerPerformanceActions.listSales(response.data.result)
            );
        }
      })
      .catch((error) => {
        CustomerPerformanceMiddleware.alertHendler(dispatch, error);
      });
  }

  static showDataMonitor(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CustomerPerformanceMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "chart/sales-performance-daily-monitor",
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
            dispatch(CustomerPerformanceActions.listMonitor(response.data.result)
            );
        }
      })
      .catch((error) => {
        CustomerPerformanceMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${CustomerPerformanceMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            CustomerPerformanceActions.process(),
            CustomerPerformanceMiddleware.showlist(dispatch, search)
          );
          dispatch(CustomerPerformanceActions.success());
          CustomerPerformanceMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        CustomerPerformanceMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              console.log(data)
              MySwal.hideLoading();
              MySwal.update({
                title: "Error",
                html: i18n.t(data.message),
                icon: "error",
                showConfirmButton: true,
              })
              const search = {limit: 10}
                dispatch(
                  CustomerPerformanceActions.process(),
                  CustomerPerformanceMiddleware.showlist(dispatch, search)
                );
          
            } else {
              const data = result.response.data;
              dispatch(CustomerPerformanceActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(CustomerPerformanceActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
